import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const BoostStarsComponent: FC<InnerIconProps> = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__boostStars"
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M7.26667 14.6573L5.10333 10.33L0.776001 8.16667L5.10333 6.00333L7.26667 1.676L9.43 6.00333L13.7573 8.16667L9.43 10.33L7.26667 14.6573ZM12.6 14.5L13.6 16.5L14.6 14.5L16.6 13.5L14.6 12.5L13.6 10.5L12.6 12.5L10.6 13.5L12.6 14.5ZM13.4887 3.61133L14.2667 5.16667L15.0447 3.61133L16.6 2.83333L15.0447 2.05533L14.2667 0.5L13.4887 2.05533L11.9333 2.83333L13.4887 3.61133Z"
        fill="url(#BoostStarsComponent)"
      />
      <defs>
        <linearGradient
          id="BoostStarsComponent"
          x1="16.5154"
          y1="1.20348"
          x2="-0.164859"
          y2="6.28315"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC796B" />
          <stop offset="1" stopColor="#E175B1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BoostStars = withIcon(BoostStarsComponent);
